function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Contact",
  transform: "translate(-100.000000, -693.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(100.000000, 295.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(0.000000, 200.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.8990845,198 L4.5667689,198 C3.2585732,198 2.17040898,198.440022 1.30224247,199.320079 C0.434076545,200.200141 3.55271368e-13,201.282361 3.55271368e-13,202.566769 L3.55271368e-13,220.833845 C3.55271368e-13,222.14204 0.434076545,223.230204 1.30224247,224.098371 C2.17040898,224.966537 3.2585732,225.400613 4.5667689,225.400613 L28.8990845,225.400613 C30.2072811,225.400613 31.2954462,224.966537 32.1636118,224.098371 C33.0317774,223.230204 33.4658534,222.14204 33.4658534,220.833845 L33.4658534,202.566769 C33.4658534,201.282361 33.0317774,200.200141 32.1636118,199.320079 C31.2954462,198.440022 30.2072811,198 28.8990845,198 Z M4.5667689,201.068298 L28.8990845,201.068298 C29.2082958,201.068298 29.4758765,201.139654 29.7018357,201.282365 C29.9277994,201.425077 30.1240243,201.651036 30.2905196,201.960247 L16.7329244,211.414884 L3.1753315,201.960247 C3.34182905,201.651036 3.53805534,201.425077 3.76401678,201.282365 C3.98997777,201.139654 4.25755892,201.068298 4.5667689,201.068298 Z M28.8990845,222.367993 L4.5667689,222.367993 C4.09106137,222.367993 3.71644749,222.23123 3.44291539,221.957698 C3.16938374,221.684166 3.03261997,221.309552 3.03261997,220.833845 L3.03261997,205.456675 L15.805304,214.447501 C15.9717993,214.518862 16.1323486,214.590213 16.286952,214.661573 C16.44156,214.732929 16.5902129,214.768605 16.7329244,214.768605 C16.8756405,214.768605 17.0242934,214.732929 17.1789013,214.661573 C17.3335047,214.590213 17.4940541,214.518862 17.6605539,214.447501 L30.4332311,205.456675 L30.4332311,220.833845 C30.4332311,221.309552 30.2964701,221.684166 30.0229389,221.957698 C29.7494077,222.23123 29.3747911,222.367993 28.8990845,222.367993 Z",
  id: "Fill-1"
})))));

function SvgMailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "28px",
    viewBox: "0 0 34 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.f8b7595b.svg";
export { ForwardRef as ReactComponent };